
















































import { Component, Vue } from 'vue-property-decorator';
import DefineYourGoalsCardViewModel from
  '@/vue-app/view-models/components/goals-dashboard/define-your-goals-card-view-model';

@Component({
  name: 'DefineYourGoalsCard',
  components: {
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
})
export default class DefineYourGoalsCard extends Vue {
  view_model = Vue.observable(new DefineYourGoalsCardViewModel());
}
